import React, {useContext, useEffect, useState} from "react";
import Moment from "react-moment";
import Money from "../core/Money";
import MoneyInterface from "../../interfaces/core/MoneyInterface";
import {OrderInterface} from "../../interfaces/dealer/OrderInterface";
import {OrderInterface as CreateOrderInterface} from "../../interfaces/dealer/create/OrderInterface";
import {OrderPositionInterface as CreateOrderPositionInterface} from "../../interfaces/dealer/create/OrderPositionInterface";
import {OrderPositionInterface} from "../../interfaces/dealer/OrderPositionInterface";
import {OrderPositionGroupedByModelInterface} from "../../interfaces/dealer/OrderPositionGroupedByModelInterface";
import ModelInterface from "../../interfaces/model/ModelInterface";
import OrderSingle from "./OrderSingle";
import {useParams, useNavigate, useOutletContext, Link} from "react-router-dom";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {OrderResponseInterface} from "../../interfaces/dealer/OrderResponseInterface";
import {OutletInterface} from "../../interfaces/dealer/OutletInterface";
import {ColorInterface} from "../../interfaces/dealer/ColorInterface";
import OrderStatistic from "./OrderStatistic";


export default function OrderList() {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const outletData = useOutletContext<OutletInterface>();

    const [currentOrderStructure, setCurrentOrderStructure] = useState<OrderPositionGroupedByModelInterface | undefined>(undefined)

    const queryData = useParams<{ orderId: string }>();

    const navigate = useNavigate();

    const [data, setData] = useState<OrderResponseInterface|undefined>(undefined);

    useEffect(() => {
        if (outletData?.ordersData) {
            setData(outletData?.ordersData)
        }
    }, [outletData?.ordersData]);


    useEffect(() => {
        if (data && queryData.orderId) {
            const order = data.orders.find(order => order.id === parseInt(queryData.orderId as string))
            if (order) {
                setCurrentOrderStructure(convertOrderToStructure(order))
            } else {
                dispatch({
                    type: ReducerActionType.ERROR,
                    payload: "Заказ " + queryData.orderId + " не найден среди ваших закзаов"
                })
            }
        }
    }, [data, queryData]);

    const getOrdersWithData = () => {
        if (!data) {
            return []
        }
        return data.orders.map(order => {
            const quantity = order.positions.reduce((acc, current) => acc + current.quantity, 0)
            const summ = order.positions.reduce((acc, current) => acc + current.quantity * (current.price_object?.amount || 0), 0)

            const currency = order.positions[0]?.price_object?.currency || 'RUB'

            // @ts-ignore
            return {
                ...order, ...{
                    positionQuantity: quantity,
                    // @ts-ignore
                    positionSumm: {amount: summ, currency: {name: currency}} as MoneyInterface
                }
            }
        })
    }

    const convertOrderToStructure = (order: OrderInterface): OrderPositionGroupedByModelInterface => {

        let groupedPositions = new Map<string, OrderPositionInterface[]>();

        order?.positions.forEach(position => {
            // @ts-ignore
            if (data?.relation[position.model_item_id]) {
                // @ts-ignore
                const modelId = data?.relation[position.model_item_id]

                let currentPositions = groupedPositions.get(modelId) || []
                currentPositions.push(position)
                groupedPositions.set(modelId, currentPositions)
            }
        })

        let orderStructure: { model: ModelInterface, positions: OrderPositionInterface[] }[] = [];

        groupedPositions.forEach((value, key) => {

            //@ts-ignore
            const model: ModelInterface = data?.models[key]
            if (model) {
                orderStructure.push({
                    model: model,
                    positions: value
                })
            }
        })

        return {order: order, groupedPositions: orderStructure}
    }

    const returnToList = () => {
        setCurrentOrderStructure(undefined)
    }

    return (
        <div>
            {!currentOrderStructure && <div className="col-md-8 offset-md-2">
                <div className="text-end">
                    <button className={'btn btn-secondary btn-small'} onClick={() => {
                        navigate('/dealer')
                    }}>&larr; в каталог
                    </button>

                </div>
                <h1>Список заказов</h1>
                <table className="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Дата оформления</th>
                        <th className={'text-end'}>Кол-во позиций</th>
                        <th className={'text-end'}>Стоимость</th>
                        <th>Статус</th>
                        <th>Комментарий</th>
                        <th>Менеджер</th>
                    </tr>
                    </thead>
                    <tbody>
                    {getOrdersWithData().map(order => <tr className={'pointer'} key={order.id}
                                                          onClick={() => navigate("/dealer/order/" + order.id)}>
                        <td>{order.id}</td>
                        <td><Moment format={"DD.MM.YYYY HH.mm"}>{order.create_date}</Moment></td>
                        <td className={'text-end'}>{order.positionQuantity}</td>
                        <td className={'text-end'}><Money value={order.positionSumm}/></td>
                        <td>{order.status.name}</td>
                        <td>{order.comment}</td>
                        <td>{order.manager?.fio}</td>
                    </tr>)}
                    </tbody>

                </table>
            </div>}
            {currentOrderStructure && <div className="col-md-6 offset-md-3">
                <OrderSingle orderStructure={currentOrderStructure} setCurrentOrderStructure={setCurrentOrderStructure} returnToList={returnToList}/>
                <hr className={'my-5'} />
                <OrderStatistic order={currentOrderStructure.order} relation={data?.relation || []} models={data?.models || []} />
            </div>}
        </div>
    )
}